// extracted by mini-css-extract-plugin
export default {"container":"game-banner_container__vZimv","inner":"game-banner_inner__2gTNj","title":"game-banner_title__1MKVv","defisTheme":"game-banner_defisTheme__18HHV"};